import { energyConstants } from "../_constants";

export function energy(
  state = {
    fetchingDetail: false,
    detail: {},
    used: {},
    usageFrequency: "timeline",
    detailItem: "0",
    chartExpanded: false
  },
  action
) {
  switch (action.type) {
    case energyConstants.TODAY_STATUS_REQUEST:
    case energyConstants.DAILY_STATUS_REQUEST:
    case energyConstants.DETAIL_REQUEST:
    case energyConstants.TIMELINE_REQUEST:
      return {
        ...state,
        fetchingDetail: true
      };
    case energyConstants.TODAY_STATUS_SUCCESS:
    case energyConstants.DAILY_STATUS_SUCCESS:
    case energyConstants.DETAIL_SUCCESS:
    case energyConstants.TIMELINE_SUCCESS:
      return {
        ...state,
        fetchingDetail: false,
        detail: action.detail
      };
    case energyConstants.TODAY_STATUS_FAILURE:
    case energyConstants.DAILY_STATUS_FAILURE:
    case energyConstants.DETAIL_FAILURE:
    case energyConstants.TIMELINE_FAILURE:
      return {
        ...state
      };
    case energyConstants.USED_SUCCESS:
      return {
        ...state,
        used: action.detail
      };
    case energyConstants.SET_USAGE_FREQUENCY:
      return {
        ...state,
        usageFrequency: action.timescale,
        detailItem: "0"
      };
    case energyConstants.SET_DETAIL_ITEM:
      return {
        ...state,
        detailItem: action.item
      };
    case energyConstants.TOGGLE_EXPANDER:
      return {
        ...state,
        chartExpanded: !state.chartExpanded
      };
    default:
      return state;
  }
}
